export const firebaseConfig = {
  apiKey: "AIzaSyDO9CNF20ZQ1u6wHlAEI54IyRRteO5ooMs",
  authDomain: "jc-clinic.firebaseapp.com",
  databaseURL: "https://jc-clinic-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jc-clinic",
  storageBucket: "jc-clinic.appspot.com",
  messagingSenderId: "436374871716",
  appId: "1:436374871716:web:5b95e45918be37443b9031",
  measurementId: "G-S99GSW1FT1",
};
